export const SESSIONS_TABLE_COLUMN_IDS = {
  date: "date",
  topic: "sessionTopic",
  participants: "participants",
  type: "type",
} as const;

export type SessionsTableColumnId =
  (typeof SESSIONS_TABLE_COLUMN_IDS)[keyof typeof SESSIONS_TABLE_COLUMN_IDS];

export const COLUMN_ID_TO_ORDER_BY: Record<
  SessionsTableColumnId,
  "scheduled_start_time" | "topic" | "participants" | "session_type"
> = {
  [SESSIONS_TABLE_COLUMN_IDS.date]: "scheduled_start_time",
  [SESSIONS_TABLE_COLUMN_IDS.topic]: "topic",
  [SESSIONS_TABLE_COLUMN_IDS.participants]: "participants",
  [SESSIONS_TABLE_COLUMN_IDS.type]: "session_type",
};

const orderByToColumnId = Object.entries(COLUMN_ID_TO_ORDER_BY).map(
  ([columnId, orderBy]) => [orderBy, columnId] as const,
);

export const ORDER_BY_TO_COLUMN_ID = Object.fromEntries(
  orderByToColumnId,
) as Record<string, SessionsTableColumnId>;

export const getOrderByFromColumnId = (
  columnId: string,
):
  | "scheduled_start_time"
  | "topic"
  | "participants"
  | "session_type"
  | undefined => COLUMN_ID_TO_ORDER_BY[columnId as SessionsTableColumnId];

export const getColumnIdFromOrderBy = (
  orderBy: string,
): SessionsTableColumnId | undefined => ORDER_BY_TO_COLUMN_ID[orderBy];
